import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import CardsList from '../components/CardsList';
import Login from '../components/Login';
import Header from '../components/Header';
import Footer from '../components/Footer';

/**
 * CardsPage
 *
 * Route: /cards  (or /:brand/:act/cards)
 *
 * - Unauthenticated users are redirected back to the root path.
 * - Authenticated users see the top welcome panel (Login in welcome mode)
 *   plus the CardsList.
 *
 * Layout:
 *   .cards-page (flex-column, min-height: 90vh, padding-top: var(--panel-height))
 *     Header
 *     panels-cont (flex: 1)
 *       Login (welcome panel)
 *       CardsList
 *     Footer (margin-top: auto → always at bottom)
 */
const CardsPage = ({ comp, auth, match }) => {
    // Guard: unauthenticated users should not see the cards page
    if (!auth.loggedIn) {
        const base = match.url.replace(/\/cards$/, '') || '/';
        return <Redirect to={base} />;
    }

    return (
        <div className="cards-page desc-font">
            <Header />

            <div className="page-inner">
                <div className="panels-cont">
                    {/* Login in its "welcome panel" state (Hi {name} + logout) */}
                    <Login />

                    <CardsList
                        comp={comp}
                        isUserPopupShown={auth.isUserPopupShown}
                    />
                </div>
            </div>

            <Footer />
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const things = state.default;
    return {
        ...ownProps,
        comp: things.competition.data,
        auth: things.auth,
    };
};

export default connect(mapStateToProps)(CardsPage);
